'use strict';

angular.module('DoohApps')
.directive('reloadSelf', ['$location', '$route', function ($location, $route) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('click', function (event) {
                if (attrs.href.replace('#', '') === $location.path())
                    $route.reload();
            });
        }
    }
}]);